import { render, staticRenderFns } from "./CompanyTableRow.vue?vue&type=template&id=48e93f2a&"
import script from "./CompanyTableRow.vue?vue&type=script&lang=js&"
export * from "./CompanyTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports